<h4>{{ blockTitle() }}</h4>
<ng-content></ng-content>
